module.exports = __webpack_public_path__ + "img/banner1.cce43c15.png";